import { render } from "./Spinner.vue?vue&type=template&id=7d609009&scoped=true&lang=pug"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=7d609009&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7d609009"

export default script